module.exports = __webpack_public_path__ + "static/media/image3.00f74649.jpg";